import { render, staticRenderFns } from "./EstatisticasCredito.vue?vue&type=template&id=f1f06878&scoped=true&"
import script from "./EstatisticasCredito.vue?vue&type=script&lang=js&"
export * from "./EstatisticasCredito.vue?vue&type=script&lang=js&"
import style0 from "./EstatisticasCredito.vue?vue&type=style&index=0&id=f1f06878&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f06878",
  null
  
)

export default component.exports